import {URL_BASE} from "../../../../Globals.ts";
import {getIdToken} from "../../../misc/miscUtils.ts";

export const toggleUsageBasedPricing = async (user: any, setUserObj: any, currentState: boolean) => {
    if (!user) return;

    try {
        const token = await getIdToken(user);
        const response = await fetch(`${URL_BASE}/api/toggleUsageBasedPricing`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                isEnabled: !currentState
            })
        });

        if (!response.ok) return;

        setUserObj({ hasUsageBasedEnabled: !currentState });
    } catch (error) {
        console.error('Error toggling usage based pricing:', error);
    }
};